import { MarketingSEO } from '@/components/seo/MarketingSEO'
import IphoneMonitoringTopicTemplate from '@/components/IphoneMonitoringTopicTemplate'
import { iphoneMonitoringTopics } from '@/data/iphoneMonitoringTopics'

const topic = iphoneMonitoringTopics.find((t) => t.slug === 'joey-desktop')!
const related = iphoneMonitoringTopics.filter((t) => t.slug !== 'joey-desktop')

export default function IPhoneMonitoringJoeyDesktop() {
  const canonicalUrl = 'https://www.joeyfamily.com/features/iphone-monitoring/joey-desktop'
  return (
    <>
      <MarketingSEO
        title={topic.title}
        description={topic.seoDescription}
        url={canonicalUrl}
        image="/img/og/open_graph.png"
        noindex
      />
      <IphoneMonitoringTopicTemplate topic={topic} relatedTopics={related} />
    </>
  )
}

